import { V3toVector3, Vector3toV3, polyIntersectsConvexPoly } from "@project-rouge/rg-three";
import { getNextThread } from "./index237.js";
import { ThreadData } from "./index197.js";
import { getForecastedThread } from "./index238.js";
import { threadToPolyOffset } from "./index239.js";
import { trimPolyFromThread } from "./index240.js";
function addThreadsToPolys({ dataset, polysDataV3, loadMode, frozenThreads }) {
  const polysData = polysDataV3.map((data) => ({
    poly: data.poly.map(V3toVector3),
    holes: data.holes.map((poly) => poly.map(V3toVector3)),
    rng: data.rng,
    edgeWeightMods: data.edgeWeightMods,
    maxWingLength: data.maxWingLength
  }));
  const boundaries = polysData.map((p) => p.poly);
  const threads = [];
  const mainThreads = [];
  for (const thread of frozenThreads) {
    trimPolys(boundaries, thread);
  }
  const context = ThreadData.getThreadContext(dataset);
  const dataToController = /* @__PURE__ */ new Map();
  for (const polyData of polysData) {
    const thread = getForecastedThread({
      context,
      boundary: polyData.poly,
      holes: polyData.holes,
      rng: polyData.rng,
      loadMode,
      edgeWeightMods: polyData.edgeWeightMods,
      maxWingLength: polyData.maxWingLength
    });
    mainThreads.push(thread);
    if (!thread)
      continue;
    threads.push(thread);
    dataToController.set(thread.data, thread);
    trimPolys(boundaries, thread.data);
  }
  const branchableMainThreads = threads.slice();
  for (const thread of mainThreads) {
    if (!thread)
      continue;
    const nextThread = getNextThread(thread, loadMode);
    if (!nextThread) {
      branchableMainThreads.splice(branchableMainThreads.indexOf(thread), 1);
      continue;
    }
    thread.save(nextThread);
    threads.push(nextThread.thread);
    dataToController.set(nextThread.thread.data, nextThread.thread);
    trimPolys(boundaries, nextThread.thread.data);
  }
  for (const thread of mainThreads) {
    if (!thread)
      continue;
    const threadOptions = [];
    if (branchableMainThreads.includes(thread)) {
      const nextThreadA = getNextThread(thread, loadMode);
      if (nextThreadA)
        threadOptions.push(nextThreadA);
    }
    const branchThread = thread.data.startThread || thread.data.endThread;
    if (branchThread) {
      const branchController = dataToController.get(branchThread.thread);
      const nextThreadB = getNextThread(branchController, loadMode);
      if (nextThreadB)
        threadOptions.push(nextThreadB);
    }
    if (threadOptions.length === 0)
      continue;
    threadOptions.sort((a, b) => b.thread.data.size - a.thread.data.size);
    const bestNextThread = threadOptions[0];
    const parent = dataToController.get(bestNextThread.thread.data.startThread.thread);
    parent.save(bestNextThread);
    threads.push(bestNextThread.thread);
    trimPolys(boundaries, bestNextThread.thread.data);
  }
  for (const thread of threads) {
    thread.data.snapToGrid();
  }
  return { threads, mainThreads };
}
function trimPolys(boundaries, thread) {
  const threadPoly = threadToPolyOffset(thread).map(Vector3toV3);
  const i = boundaries.indexOf(thread.boundary);
  const prevBoundaries = boundaries.slice(0, i);
  const postBoundaries = boundaries.slice(i + 1);
  for (let x = 0; x < prevBoundaries.length; x++) {
    trimPoly(boundaries[x], threadPoly);
  }
  for (let x = 0; x < postBoundaries.length; x++) {
    trimPoly(boundaries[x + i + 1], threadPoly);
  }
}
function trimPoly(poly, threadPoly) {
  const polyV3 = poly.map(Vector3toV3);
  if (!polyIntersectsConvexPoly(polyV3, threadPoly))
    return;
  const trimmedPoly = trimPolyFromThread(polyV3, threadPoly);
  poly.length = 0;
  poly.push(...trimmedPoly);
}
export {
  addThreadsToPolys
};
//# sourceMappingURL=index189.js.map
